
import Button from '@/components/base/Button';

export default function FeaturedPost() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Featured Article
          </span>
          <h2 className="text-2xl font-bold text-gray-900">Latest Insights</h2>
        </div>

        <article className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl overflow-hidden shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="order-2 lg:order-1 p-8 lg:p-12 flex flex-col justify-center">
              <div className="flex items-center mb-4">
                <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold mr-3">
                  Case Study
                </span>
                <span className="text-gray-500 text-sm">March 15, 2024</span>
              </div>
              
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                How We Increased Conversion Rates by 340% for an E-commerce Client
              </h2>
              
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Discover the exact strategies we used to transform a struggling e-commerce funnel into a revenue-generating machine. Learn about our 5-step optimization process and the specific changes that made the biggest impact.
              </p>
              
              <div className="flex items-center mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20consultant%20headshot%2C%20expert%20advisor%2C%20confident%20smile%2C%20business%20attire%2C%20modern%20office%20background%2C%20marketing%20specialist%20portrait&width=60&height=60&seq=author-sarah&orientation=squarish"
                  alt="Sarah Johnson"
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-semibold text-gray-900">Sarah Johnson</div>
                  <div className="text-gray-500 text-sm">Founder & CEO</div>
                </div>
              </div>
              
              <Button variant="primary" size="lg" className="whitespace-nowrap self-start">
                <i className="ri-arrow-right-line mr-2"></i>
                Read Full Case Study
              </Button>
            </div>
            
            <div className="order-1 lg:order-2">
              <img
                src="https://readdy.ai/api/search-image?query=E-commerce%20success%20visualization%20with%20growing%20charts%2C%20online%20shopping%20interface%2C%20conversion%20optimization%20dashboard%2C%20business%20growth%20metrics%2C%20professional%20analytics%20display&width=600&height=500&seq=featured-blog&orientation=portrait"
                alt="E-commerce conversion optimization case study"
                className="w-full h-64 lg:h-full object-cover"
              />
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}